<ng-template #tooltip>
  <div class="box-shadow"></div>
  <a
    *ngFor="let cat of tooltipCategories; let isLast = last"
    [routerLink]="['/results']"
    [queryParams]="{ categories: [cat.category_id] }"
    queryParamsHandling="merge"
  >
    {{ cat.category_title + (!isLast ? ", " : "") }}
  </a>
</ng-template>

<div
  class="category-badge"
  [ngClass]="cssClassAddOn"
  [attr.title]="title"
  [ngbTooltip]="tooltipCategories?.length ? tooltip : ''"
  placement="top"
  container="body"
  triggers="click:blur"
  tooltipClass="category-badge-tooltip"
>
  <p class="category-badge__text text-small" [ngClass]="cssClassTextAddOn">
    <ng-content></ng-content>
  </p>
</div>
